import React from 'react';
import { motion } from 'framer-motion';
export function SystemSection() {
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8" data-id="element-262">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-263">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4 max-w-3xl mx-auto" data-id="element-264">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-black leading-tight" data-id="element-265">
            El Protocolo H.E.R. —{' '}
            <span className="text-gradient-gold" data-id="element-266">
              Sistema completo de 21 días
            </span>
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 font-body leading-relaxed" data-id="element-267">
            Un método simple diseñado para acompañar los cambios reales del
            cuerpo femenino después de los 35.
          </p>

          <div className="flex flex-col items-start gap-4 text-left max-w-lg mx-auto pt-4" data-id="element-268">
            <div className="flex items-start gap-3" data-id="element-269">
              <span className="text-secondary font-bold mt-0.5" data-id="element-270">✔️</span>
              <span className="text-foreground/90 font-body font-medium leading-relaxed" data-id="element-271">
                Menos hinchazón al final del día
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-272">
              <span className="text-secondary font-bold mt-0.5" data-id="element-273">✔️</span>
              <span className="text-foreground/90 font-body font-medium leading-relaxed" data-id="element-274">
                Más energía estable y menos antojos
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-275">
              <span className="text-secondary font-bold mt-0.5" data-id="element-276">✔️</span>
              <span className="text-foreground/90 font-body font-medium leading-relaxed" data-id="element-277">
                Un sistema claro que podés sostener
              </span>
            </div>
          </div>

          <p className="text-base md:text-lg text-foreground/70 font-body font-medium leading-relaxed pt-4" data-id="element-278">
            👉 Sin dietas extremas. Sin improvisar. Sin empezar de cero cada
            semana.
          </p>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex justify-center" data-id="element-279">
          <div className="relative w-full max-w-md" data-id="element-280">
            <div className="rounded-2xl shadow-gold overflow-hidden border border-gold/20" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/9CoabbCkKCL8Xo8LBKnvLe/cosmos-image-1774831434473.png" alt="Sistema H.E.R. Digital" className="w-full h-auto object-cover bg-card/50" data-id="element-282" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}